import axios from "axios";
import parseJwt from "../../util/JwtParser";
import { authenticatedHeader } from "../DefaultConfig";
import { AuthenticationURL } from "../Services";
import { HideAwaiting } from "../../util/Awaiting";

export async function refreshToken() {
  if (localStorage["accessToken"]) {
    var expiredAccessTime = parseJwt(localStorage["accessToken"])["exp"];
    var now = Math.floor(Date.now() / 1000);
    if ((expiredAccessTime < now + 300) && (expiredAccessTime > now - 3600 * 48)) {
      var result = (
        await axios.post(
          AuthenticationURL + "api/token/refresh",
          {
            token: "",
          },
          authenticatedHeader()
        )
      ).data;
      localStorage.setItem("accessToken", result["token"]);
      HideAwaiting();
    }
  }
}
